import { Modal } from "antd";
import React from "react";

function NotificationDetail({ props }) {
  const { isModal, onClose, isDetail } = props;

  return (
    <Modal
      title={null}
      visible={isModal}
      onOk={null}
      onCancel={null}
      footer={null}
      closable={false}
      keyboard={false}
      width={400}
    >
      <div>
        <div className="flex justify-center">
          <img
            src={
              process.env.REACT_APP_BASE_URL + "/assets/icon/ic_notif_promo.svg"
            }
            alt="icon-promo"
            className="w-20 h-20"
          />
        </div>
        <p className="text-center mt-5 mb-3 text-2xl header-title-bold">
          {isDetail?.title ?? ""}
        </p>
        <p className="header-title mt-1 text-center">
          {isDetail?.content ?? ""}
        </p>
        <button
          onClick={() => onClose()}
          className="btn-blue w-full p-3 mt-8 focus:outline-none"
        >
          <p className="text-white lg:text-lg">Tutup</p>
        </button>
      </div>
    </Modal>
  );
}

export default NotificationDetail;
